import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type {
  ListingComplaintProcessViewModel,
  ListingComplaintProcessCreateModel,
  ListingComplaintProcessUpdateModel,
} from '../types/listing-complaint-process';
import { apiClient } from '../client/client';

export class ListingComplaintProcessService extends BaseService<
  ListingComplaintProcessViewModel,
  ListingComplaintProcessCreateModel,
  ListingComplaintProcessUpdateModel,
  ListingComplaintProcessViewModel[]
> {
  private static readonly BASE = '/api/listing-complaint-process';

  constructor(client: AxiosInstance = apiClient) {
    super(client, ListingComplaintProcessService.BASE);
  }
}

export const listingComplaintProcessService = new ListingComplaintProcessService();
